<template>
  <div class="w-full min-h-screen text-white bg-black">
    <!-- Hero com fade -->
    <section
      class="relative bg-cover bg-center"
      :style="{ backgroundImage: bgImage }"
    >
      <div class="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent"></div>

      <div
        class="relative z-10 flex min-h-[70svh] flex-col justify-center items-start px-8 md:px-24 py-16 md:py-24"
      >
        <JumbotronHome :title="'treinamento em destaque'">
          <template #tag>
            <p
              class="font-ufc-force text-[#D20A0A] text-xl md:text-2xl italic uppercase font-bold w-full mt-8 -mb-3"
            >
              {{ mainEvent?.event?.tag }}
            </p>
          </template>

          <template #principal>
            <div class="font-berthold-force italic font-bold text-white">
              <h2
                class="text-5xl md:text-7xl font-extrabold my-4 tracking-widest"
              >
                {{ mainEvent?.event?.title }}
              </h2>
            </div>
          </template>

          <template #descript>
            <div
              class="font-extralight text-white my-3 tracking-wide text-2xl font-berthold-force w-full md:w-1/2"
            >
              {{
                mainEvent?.event?.description?.length > 90
                  ? mainEvent?.event?.description.slice(0, 90).concat('...')
                  : mainEvent?.event?.description
              }}
            </div>
          </template>

          <template #button>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer pt-10 md:pt-2"
            >
              <a
                @click="goToPurchase(mainEvent?.event?.id)"
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
              >
                <label
                  class="pb-3 mt-2 md:text-3xl text-xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer flex"
                >
                  ASSISTA AO TREINAMENTO
                  <PhTicket class="w-8 h-8 ml-3 -rotate-45" />
                </label>
              </a>
            </div>
          </template>
        </JumbotronHome>
      </div>
    </section>

    <!-- MEUS TREINAMENTOS -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        MEUS TREINAMENTOS
      </h2>

      <div v-if="customer?.purchases?.length && customer?.purchases[0]?.event">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in customer?.purchases"
            :key="index"
            :image="
              item?.event?.banner !== null && item?.event?.banner !== '[]'
                ? fileUrl + item?.event?.banner
                : banner
            "
            :title="item?.event?.title"
            :date="formatDate(item?.event?.date)"
            :live="item?.event?.is_live"
            @click="watchEvent(item?.event?.id, item?.group_id)"
          />
        </Carrossel>
      </div>

      <div class="w-full py-3 italic" v-else>
        Você não esta cadastrado em nenhum treinamento
      </div>
    </section>

    <!-- VEJA TAMBÉM -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        VEJA TAMBÉM
      </h2>

      <Carrossel>
        <CardEventoPreview
          v-for="(item, index) in shuffleArray(e)"
          :key="index"
          :image="item.banner !== null && item.banner !== '[]' ? fileUrl + item.banner : banner"
          :title="item.title"
          :date="formatDate(item.date)"
          :live="item.is_live"
          @click="goToPurchase(item.id)"
        />
      </Carrossel>
    </section>
  </div>
</template>

<script setup>
import { onBeforeMount, computed, ref } from 'vue'
import { dataShared } from '@/shared/store'
import CardEventoPreview from '../auth/components/CardEventoPreview.vue'
import JumbotronHome from '@/shared/components/__partials/JumbotronHome.vue'
import { PhTicket } from '@phosphor-icons/vue'
import router from '@/router'
import SharedService from '@/shared/services/shared'
import { formatDate } from '@/utils/formaters'
import 'moment/locale/pt-br'
import { showToast as toast } from '@/helpers/UseToasts'
import Carrossel from '../auth/components/_partials/Carrossel.vue'
import appBanner from './../../../assets/logo/plataforma_x/xsolution_logo.png'

const banner = require('@/assets/logo/icon.png')
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const mainEvent = computed(() => dataShared.getters.getMainEvent)
const customer = computed(() => dataShared.getters.getDataByUserLogged)
const e = computed(() => dataShared.getters.getEvents) // events collect

const bgImage = computed(() => { // to style
  const raw = mainEvent?.value?.event?.banner
  const hasBanner = raw && String(raw).trim() !== '' && raw !== 'null'
  const url = hasBanner ? `${fileUrl}${raw}` : appBanner
  return `url('${url}')`
})

async function watchEvent (id, groupId = null) {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(id)
    .then((res) => {
      dataShared.dispatch('setEventToPurchase', id)
      console.log(res.data);
      if (res.data.success == false) {
        dataShared.dispatch('desactiveLoading')
        toast('Aviso', 'Solicite acesso ao treinamento', 'info')
        return router.push(`/training/${id}/purchase`)
      }

      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setLiveActive', id)
      router.push({
        path: `/module/${id}`,
        query: groupId ? { group: groupId } : {},
      })
    })
    .catch((err) => {
      console.log(err)
    })
}

async function goToPurchase (id) {
  if(id)
    router.push(`/training/${id}/purchase`)
}

// function formatDateFull (dateString) {
//   return moment(dateString).format('dddd, D [de] MMMM [de] YYYY')
// }

async function getMainEvent () {
  dataShared.dispatch('activeLoading')
  await SharedService.getMainEvent()
    .then((res) => {
      dataShared.dispatch('setMainEvent', res.data.mainEvent)
    })
    .catch((err) => {
      console.log(err)
    })
}

async function getAllEvents () {
  dataShared.dispatch('activeLoading')
  await SharedService.getEvents()
    .then((res) => {
      dataShared.dispatch('setAllEvents', res.data)
      console.log(res.data);
    })
    .catch((err) => {
      console.log(err)
    })
}

function shuffleArray (array) {
  const a = array.slice()
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

onBeforeMount(() => {
  dataShared.dispatch('activeLoading')
  Promise.all([
    getAllEvents(), 
    getMainEvent(),
    dataShared.dispatch('fetchLoggedUser')
  ])
  dataShared.dispatch('desactiveLoading')
})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
